import React from 'react';
import { IOrder } from '@/interfaces/order';
import DeliveryStep from './delivery-status-step';
import DeliveryDriver from './delivery-driver';

import { Col, Row } from 'antd';
import DeliveryPallet from './delivery-pallet';
import DeliveryDocUploader from './delivery-doc-uploader';
import DeliveryMap from './delivery-map';
import DeliveryDocPrint from './delivery-doc-print';

interface IProps {
  data: IOrder;
  onActioned: () => void;
}

const DeliveryNoteStatus: React.FC<IProps> = ({ data, onActioned }) => {
  return (
    <div className="flex flex-col gap-3 w-full">
      <DeliveryStep data={data} />
      <DeliveryDriver data={data} onActioned={onActioned} />
      <Row gutter={[12, 12]}>
        <Col md={8} span={24}>
          <DeliveryMap data={data} />
        </Col>
        <Col md={16} span={24}>
          <div className="flex flex-col gap-3">
            <DeliveryPallet data={data} />
            <DeliveryDocUploader data={data} />
            <DeliveryDocPrint data={data} />
          </div>
        </Col>
      </Row>
    </div>
  );
};

export default DeliveryNoteStatus;
